module.exports = __webpack_public_path__ + "static/media/success.a39188ff.svg";